import React from 'react';
import { Row, Col, Button } from 'antd';
import './assets/css/package.css';
import dummyImage from './assets/Rectangle 187.png';
import calendarIcon from './assets/calendar 1.png';

function PackageDetails() {
  return (
    <div className='booking-container'>
      <div
        className='package-details-container details'
        style={{ marginTop: 140 }}
      >
        <Row gutter={[40, 20]} className='package-row '>
          {/* Left Image Section */}

          {/* Right Content Section */}
          <Col
            //  xs={24} md={14}
            xs={{ order: 2, span: 24 }}
            md={{ span: 14, order: 1 }}
            className='package-content'
          >
            <h3 className='package-title'>
              TWO ANGLERS | TWO ROOMS | TWO NIGHTS | TWO DAYS FISHING
            </h3>
            <p className='package-description'>
              This is an example of the best Exotic Fishing Thailand package
              description you could ever think of. This is the best resort in
              Thailand and there is not another that even comes close.
            </p>

            {/* Features */}
            <Row gutter={[10, 10]} className='details-package-features'>
              <Col xs={12} sm={8}>
                <span className='feature-item'>
                  <img
                    src={calendarIcon}
                    width={14}
                    height={14}
                    alt='benefit'
                    className='mg-right-5'
                  />{' '}
                  Resort With High-Speed WiFi
                </span>
              </Col>
              <Col xs={12} sm={8}>
                <span className='feature-item'>✅ Breakfast Included</span>
              </Col>
              <Col xs={12} sm={8}>
                <span className='feature-item'>✅ Transfer Included</span>
              </Col>
              <Col xs={12} sm={8}>
                <span className='feature-item'>✅ Boat Included</span>
              </Col>
              <Col xs={12} sm={8}>
                <span className='feature-item'>
                  ✅ Use of Rods and Reels (1x Per Angler)
                </span>
              </Col>
              <Col xs={12} sm={8}>
                <span className='feature-item'>
                  ✅ Use of Check-Out Included
                </span>
              </Col>
            </Row>

            {/* Pricing */}
            <div className='package-pricing'>
              <div className='package-details-price-container mg-bottom-10  row-center justify-between'>
                <span className='package-price-label   font-montserrat sb-blue-700'>
                  PACKAGE PRICE
                </span>
                <div className='package-price  sb-blue-bg-100 font-montserrat sb-blue-700'>
                  £450.00
                </div>
              </div>
              <div className='package-details-price-container  row-center justify-between'>
                <span className='package-price-label   font-montserrat sb-blue-700'>
                  PAY TODAY
                </span>
                <div className='package-price  sb-blue-bg-100 font-montserrat sb-blue-700'>
                  £150.00
                </div>
              </div>
            </div>

            {/* Booking Button */}
            <Button className='details-book-button'>
              CHECK AVAILABILITY & BOOK NOW
            </Button>
          </Col>
          <Col
            xs={{ order: 1, span: 24 }}
            md={{ span: 10, order: 2 }}
            className='package-image-container'
          >
            <div className='package-image-wrapper'>
              <img
                src={dummyImage}
                alt='Fishing Package'
                className='package-details-image'
              />
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
}

export default PackageDetails;
